export enum RumorStatus {
  IN_PROGRESS = 'IN_PROGRESS',
  KO_NOT_INTERESTED = 'KO_NOT_INTERESTED',
  KO_NOT_CONFIRMED = 'KO_NOT_CONFIRMED',
  KO_DUPLICATE_LEAD = 'KO_DUPLICATE_LEAD',
  APPOINTMENT_SCHEDULED = 'APPOINTMENT_SCHEDULED',
}
